import {action, createAsync, redirect, RouteDefinition} from "@solidjs/router";
import {For} from "solid-js";
import {getUser} from "~/api/auth";
import {getPetsByOwner} from "~/api/pets";
import {getTagsByUser, updateTag} from "~/api/tags";
import Container from "~/components/Container";
import Page from "~/components/Page";
import Section from "~/components/Section";
import css from "~/css/routes/dashboard/tags.module.css"

const updateTagAction = action(async (id: string, user_id: string | undefined, data: FormData) => {
    "use server";
    const pet_id = data.get("pet_id") as string;
    const payload = {pet_id, user_id};
    await updateTag(id, payload);
    throw redirect("/dashboard/tags");
}, "updateTag")

export const route = {
    preload: async () => {
        const user = await getUser()
        if (user) {
            await getPetsByOwner(user.id)
            await getTagsByUser(user.id)
        }
        return user
    }
} satisfies RouteDefinition

export default function TagsPage() {

    const user = createAsync(async () => await getUser())
    const tags = createAsync(async () => await getTagsByUser(user()?.id!))
    const pets = createAsync(async () => await getPetsByOwner(user()?.id!))

    return (
        <Page>
            <Container>
                <h1>Tags</h1>
            </Container>
            <Section>
                <Container>
                    <div class={css.list}>
                        <For each={tags()}>
                            {(tag) => (
                                <div class={css.tag}>
                                    <p>🏅 {tag.id}</p>
                                    {/*TODO use modular-forms. Form dirty status to suggest saving*/}
                                    <form action={updateTagAction.with(tag.id, tag.user_id)} method="post">
                                        <select name="pet_id">
                                            <For each={pets()}>
                                                {(pet) => (
                                                    <option value={pet.id}
                                                            selected={tag.pet_id == pet.id}>{pet.name}</option>
                                                )}
                                            </For>
                                        </select>
                                        <button type="submit">Update</button>
                                    </form>
                                </div>
                            )}
                        </For>
                    </div>
                </Container>
            </Section>
        </Page>
    );
}